var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-preview"},[(!_vm.opponentMessage)?_c('span',{staticClass:"message-preview__author"},[_vm._v(_vm._s(_vm.$t("You"))+": ")]):_vm._e(),_c('span',{class:{ link: _vm.isAttachmentOnly }},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }